import { BranchTypes, OrganizationTypes } from '../interfaces/organization'

type WithBranches = Pick<OrganizationTypes, 'branch'>

/**
 * An organisation's branches as a plain list.
 *
 * The backend says "no branches" in three different ways: the key absent
 * (`OrganizationWithSubscriptionListSerializer` and the detail serializer omit
 * it), `null` (`OrganizationSerializer.to_representation` sets None when the
 * queryset is empty), and `[]` (what a plain `BranchSerializer(many=True)`
 * field would return, were the backend ever to declare one). Read branches
 * through here so a serializer change cannot crash a reporter mid-report.
 */
export const branchesOf = (organization?: WithBranches | null): BranchTypes[] =>
  organization?.branch ?? []

/** Whether the organisation files its reports under branches at all. */
export const hasBranches = (organization?: WithBranches | null): boolean =>
  branchesOf(organization).length > 0
